import { Get } from "domain/infra/data/api";
import CampanhaConstants from "../../infra/data/campanhaConstants";
import { CampanhaUsuarioResponse } from "../../types/campanhaUsuario/campanhaUsuarioResponse";
import { CampanhaPedidoExtratoResponse } from "../../types/campanhaPedidoExtrato/campanhaPedidoExtratoResponse";

export class CampanhaUsuarioService {
  constructor() {
  }
  async GetCampanhaUsuario(usuarioId: number, campanhaId: number): Promise<CampanhaUsuarioResponse | Error> {
    return await Get(`${CampanhaConstants.apiCampanha.CampanhasUsuario.getCampanhaUsuario}?campanhaId=${campanhaId}&usuarioId=${usuarioId}`)
  }

  async GetCampanhaPedidoExtrato(usuarioId: number, campanhaId: number): Promise<CampanhaPedidoExtratoResponse[] | Error> {
    return await Get(`${CampanhaConstants.apiCampanha.CampanhaPedidoResgate.extrato}?campanhaId=${campanhaId}&usuarioId=${usuarioId}`)
  }
}
